/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';
import { useNotifications } from '@/data/Content/Notifications';
import { useLocalization } from '@/data/Localization';
import { useSettings } from '@/data/Settings';
import { TransactionErrorResponse } from '@/data/types/Basic';
import { processError } from '@/data/utils/processError';
import { customTransactionsNewsletterSubscriptions } from 'integration/generated/customTransactions';
import { RequestParams } from 'integration/generated/transactions/http-client';

type newsLetterSubscriptionType = {
	emailId: string;
	babyPeuter?: boolean;
	gaming?: boolean;
};

export const newsLetterSubscriptionFetcher =
	(pub: boolean) =>
		async (
			storeId: string,
			query: {
				[key: string]: string | number | boolean;
			},
			params: RequestParams
		) =>
			await customTransactionsNewsletterSubscriptions(pub).newsLetterSubscriptionAddNewsLetterDetailsCreate(
				storeId,
				query,
				params
			);
export const subscribeFetcher =
	(pub: boolean) =>
		async (
			storeId: string,
			query: {
				[key: string]: string;
			},
			params: RequestParams
		) =>
			await customTransactionsNewsletterSubscriptions(pub).newsLetterSubscriptionSubscribeCreate(
				storeId,
				query,
				params
			);

export const unSubscribeFetcher =
(pub: boolean) =>
	async (
		storeId: string,
		query: {
			[key: string]: string | number | boolean;
		},
		params: RequestParams
	) =>
		await customTransactionsNewsletterSubscriptions(pub).newsLetterSubscriptionUnsubscribeCreate(
			storeId,
			query,
			params
		);

const initSubscriptionValues: newsLetterSubscriptionType = {
	emailId: ''
};


export const useNewsLetterSubscription = () => {
	const { settings } = useSettings();
	const newsLetterNLS = useLocalization('NewsLetterSubscription');
	const params = useExtraRequestParameters();
	const { showSuccessMessage, notifyError } = useNotifications();

	const userSubscriptionSubmit = async (props: newsLetterSubscriptionType) => {
		const query = {
			x_rubyStore: true,
			emailId: props.emailId
		};
		try {
			await newsLetterSubscriptionFetcher(true)(settings?.storeId ?? '', query, params);
			showSuccessMessage(newsLetterNLS.SuccessLabel.t([query.emailId]));
		} catch (e) {
			notifyError(processError(e as TransactionErrorResponse));
		}
	};

	const userUnSubscribeSubmit = async (emailId:string) => {
		const contactListId = settings.userData.NewsLetterSubscriptionContactListId;
		const query = {
			x_rubyStore:true,
			emailId,
			contactListId
		}
		try {
			await unSubscribeFetcher(true)(settings?.storeId ?? '', query, params);
			showSuccessMessage(newsLetterNLS.SuccessLabel.t([query.emailId]));
		} catch (e) {
			notifyError(processError(e as TransactionErrorResponse));
		}
	}

	const sendNewsLetterSubsc = async (emailId: string, contactListId: string, interestValue: boolean) => {
		const query = {
			emailId: emailId,
			contactListId: contactListId
		};
		// const data = { Needed ?
		// 	x_rubyStore: true,
		// };
		if (interestValue) {
			try {
				await subscribeFetcher(true)(settings?.storeId ?? '', query, params);
			} catch (e) {
				notifyError(processError(e as TransactionErrorResponse));
			}
		} else {
			try {
				await unSubscribeFetcher(true)(settings?.storeId ?? '', query, params);
			} catch (e) {
				notifyError(processError(e as TransactionErrorResponse));
			}
		}

	};

	return {
		initSubscriptionValues,
		userSubscriptionSubmit,
		userUnSubscribeSubmit,
		sendNewsLetterSubsc
	};
};
